export const NAME_MAX_LENGTH = 50;
export const ID_MAX_LENGTH = 20;
export const EMAIL_MAX_LENGTH = 62;
export const DAY_MAX_LENGTH = 2;
export const MONTH_MAX_LENGTH = 2;
export const YEAR_MAX_LENGTH = 4;
export const PHONE_MAX_LENGTH = 10;
